import { footerLinks } from "@/mocks/home";

export default function CtaFooter() {
  return (
    <>
      {/* 追更 CTA */}
      <section id="cta" className="scroll-mt-24 bg-background-50">
        <div className="mx-auto w-full max-w-7xl px-4 pb-16 md:px-6 md:pb-20">
          <div className="relative overflow-hidden rounded-xl bg-primary-500 px-6 py-12 text-center md:py-16">
            <div className="absolute inset-0 opacity-20">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20abstract%20soft%20coral%20light%20bokeh%20gradient%20background%2C%20gentle%20glowing%20particles%2C%20clean%20and%20calm%2C%20no%20text&width=1600&height=400&seq=fuli-cta&orientation=landscape"
                alt=""
                className="h-full w-full object-cover"
              />
            </div>
            <div className="relative">
              <h2 className="mx-auto max-w-2xl text-2xl font-black leading-snug text-background-50 md:text-3xl">
                每天想看「福利岛今日更新」，把它设为你的固定站点
              </h2>
              <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-background-50/85">
                新内容速递与最新合集都在这里持续更新。收藏本站或加入追更提醒，不错过每一次上新。
              </p>
              <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
                <a href="#feed" className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-semibold text-primary-700 hover:bg-background-100 transition-colors">
                  <i className="ri-refresh-line" aria-hidden="true" />回看今日上新
                </a>
                <a href="#talk" className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-background-50/10 transition-colors">
                  <i className="ri-notification-3-line" aria-hidden="true" />开启更新提醒
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 厚壳页脚 */}
      <footer className="bg-background-100">
        <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6">
          <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
            <div className="md:col-span-5">
              <div className="flex items-center gap-2">
                <span className="grid h-9 w-9 place-items-center rounded-lg bg-primary-500 text-background-50">
                  <i className="ri-gift-2-fill text-lg" aria-hidden="true" />
                </span>
                <span className="font-brand text-2xl leading-none text-foreground-950">福利岛</span>
              </div>
              <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
                福利岛是一个偏社区讨论的每日更新站点。整理今日更新、新内容速递与最新合集，陪你追更找新料、收藏好内容，越逛越有收获。
              </p>
              <div className="mt-5 flex items-center gap-2">
                <span className="rounded-md border border-background-200 bg-background-50 px-3 py-1.5 text-xs text-foreground-600">每日 09:00 更</span>
                <span className="rounded-md border border-background-200 bg-background-50 px-3 py-1.5 text-xs text-foreground-600">热门板块持续运转</span>
              </div>
            </div>

            <div className="md:col-span-2">
              <h4 className="text-sm font-bold text-foreground-950">快速导航</h4>
              <ul className="mt-4 space-y-2.5">
                {footerLinks.quick.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-sm text-foreground-600 hover:text-primary-600">{l.label}</a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="md:col-span-2">
              <h4 className="text-sm font-bold text-foreground-950">站点信息</h4>
              <ul className="mt-4 space-y-2.5">
                {footerLinks.about.map((l) => (
                  <li key={l}><a href="#top" className="text-sm text-foreground-600 hover:text-primary-600">{l}</a></li>
                ))}
              </ul>
            </div>

            <div className="md:col-span-3">
              <h4 className="text-sm font-bold text-foreground-950">需要帮助</h4>
              <ul className="mt-4 space-y-2.5">
                {footerLinks.help.map((l) => (
                  <li key={l}><a href="#top" className="text-sm text-foreground-600 hover:text-primary-600">{l}</a></li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-12 flex flex-col items-start gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
            <p>© 2026 福利岛 · 本站为内容浏览站，仅做展示用途。</p>
            <div className="flex items-center gap-4">
              <a href="#top" className="hover:text-primary-600">回到顶部 <i className="ri-arrow-up-line" aria-hidden="true" /></a>
              <span className="flex items-center gap-1.5"><i className="ri-time-line" aria-hidden="true" />内容每日更新</span>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}